import { Fragment } from "react";
import PropTypes from "prop-types";
import OfferList from "./OfferList.jsx";
import AvailableDurations from "app/pages/.shared/AvailableDurations";
import Loader from "app/pages/.shared/Loader.jsx";
import PaymentDescriptionTermsContainer from "app/pages/Booking/Payment/PaymentDescriptionTerms/PaymentDescriptionTermsContainer";

export const SearchEngineOffers = ({
	prePackageOffers = [],
	onOfferChange,
	allAvailableDurations = [],
	productPriceValue,
}) => {
	const hasPrepackageOffers = prePackageOffers.length > 0;
	return (
		<div className="search-engine__offer">
			{(hasPrepackageOffers && (
				<Fragment>
					<OfferList offers={prePackageOffers} onOfferChange={onOfferChange} />
				</Fragment>
			)) || (
				<div className="search-engine__loader">
					<Loader />
				</div>
			)}

			{productPriceValue && <PaymentDescriptionTermsContainer />}

			{allAvailableDurations.length > 1 && Number(productPriceValue) > 0 && (
				<div className="search-engine__available-durations">
					<AvailableDurations durations={allAvailableDurations} />
				</div>
			)}
		</div>
	);
};

SearchEngineOffers.propTypes = {
	prePackageOffers: PropTypes.array,
	onOfferChange: PropTypes.func,
	productPriceValue: PropTypes.string,
	allAvailableDurations: PropTypes.arrayOf(PropTypes.number),
};
